module.exports = __webpack_public_path__ + "img/we.f30fd8bf.png";